import { Deferred } from "../../../Helpers/Deferred";
import {
    EmployerDocument,
    EmployerNormalizedTag,
    ImportEmployerDocumentsFilterType,
    ImportEmployerDocumentsOptions,
} from "../../EmployeeServiceTypes";

export enum EmployerDocumentsActionType {
    BeginImport = "EmployerDocumentsAction.BeginImport",
    ChangeFilterType = "EmployerDocumentsAction.ChangeFilterType",
    ChangeFilterValue = "EmployerDocumentsAction.ChangeFilterValueValue",
    BeginLoading = "EmployerDocumentsAction.BeginLoading",
    CompleteLoading = "EmployerDocumentsAction.CompleteLoading",
    EndImport = "EmployerDocumentsAction.EndImport",
    ChangePage = "EmployerDocumentsAction.ChangePage",
}

export type EmployerDocumentsAction =
    | {
          type: EmployerDocumentsActionType.BeginImport;
          payload: {
              deferredResult: Deferred<EmployerNormalizedTag | undefined>;
              options: ImportEmployerDocumentsOptions;
              filterType?: ImportEmployerDocumentsFilterType;
              filterValue?: string | number;
          };
      }
    | {
          type: EmployerDocumentsActionType.ChangeFilterType;
          payload: {
              filterType: ImportEmployerDocumentsFilterType;
          };
      }
    | {
          type: EmployerDocumentsActionType.ChangeFilterValue;
          payload: {
              filterValue: string | number;
          };
      }
    | {
          type: EmployerDocumentsActionType.BeginLoading;
      }
    | {
          type: EmployerDocumentsActionType.CompleteLoading;
          payload: {
              documents: EmployerDocument[];
          };
      }
    | {
          type: EmployerDocumentsActionType.EndImport;
      }
    | {
          type: EmployerDocumentsActionType.ChangePage;
          payload: {
              pageNumber: number;
          };
      };
